import { z } from 'zod';

import { IsoDateTimeSchema } from '../shipments/shipments-types.js';
import { CoverShipmentHeaderSchema } from './cover-shipments-shared.schema.js';
import type {
  MarkCoverShipmentDepartedRequest,
  MarkCoverShipmentDepartedResponse,
} from './mark-cover-shipment-departed.dto.js';

export const MarkCoverShipmentDepartedRequestSchema: z.ZodType<MarkCoverShipmentDepartedRequest> = z
  .object({
    companyId: z.uuid(),
    coverShipmentId: z.uuid(),
    stationId: z.uuid(),
    departedAt: IsoDateTimeSchema.optional(),
  })
  .strict();

export const MarkCoverShipmentDepartedResponseSchema: z.ZodType<MarkCoverShipmentDepartedResponse> =
  z
    .object({
      coverShipment: CoverShipmentHeaderSchema,
    })
    .strict();
